import { InsuranceAge } from "@/case/models/CreateInsuranceCaseViewModel";

export interface AdInsuranceModel {
  adId: string;
  age: InsuranceAge | "";
  monthlyPremium: string;
}

export function InsuranceGiftVoucherPromotionActive(): boolean {
  const now = new Date().toISOString();
  return now > "2026-08-12" && now < "2026-09-12";
}